import { create } from "zustand";
import type { ForgotPasswordState } from "./types";

export const useForgotPasswordStore = create<ForgotPasswordState>((set) => ({
  isLoading: false,
  errorMessage: null,
  phone: "",
  setPhone: (phone) => set({ phone }),
  setLoading: (loading) => set({ isLoading: loading }),
  setError: (message) => set({ errorMessage: message }),
  reset: () => set({ isLoading: false, errorMessage: null, phone: "" }),
}));
